import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AngularFireDatabase, AngularFireList } from '@angular/fire/database';
import 'rxjs/add/operator/map';
import { ObjectUtils } from '../utils/object.utils';
import { take } from 'rxjs/operators';

@Injectable()
export class PlayerService {
  playersRef: AngularFireList<any>;
  players: Observable<any[]>;

  constructor(public afd: AngularFireDatabase) {
    this.playersRef = afd.list('players');
  }

  getPlayer(userUid: string) {
    let playerRef = this.afd.list('players/' + userUid);
    // todo improve (dirty quick map)
    return playerRef.snapshotChanges().map(changes => {
      let result = ObjectUtils.mergeArrayOfObjects(
        changes.map(c => ({ [c.payload.key]: c.payload.val() }))
      );
      const isEmptyObjectResult: boolean = ObjectUtils.isEmptyObject(result);
      if (isEmptyObjectResult) {
        result = {
          achievements: []
        };
      } else {
        /* result.achievements =
          result.achievements && result.achievements.length > 0
            ? result.achievements[0]
            : []; */

        /* result.displayName = result.displayName[0];
        result.uid = result.uid[0]; */
      }
      return result;
    });
  }

  addPlayer(user: { uid: string; displayName: string }) {
    if (user) {
      this.afd.object(`players/${user.uid}`).update(user);
    } else {
      console.error('addPlayer - error: no user found');
    }
  }

  updatePlayerAchievements(user, achievements) {
    if (user) {
      this.afd.object(`players/${user.uid}/achievements`).update(achievements);
    } else {
      console.error('addPlayer - error: no user found');
    }
  }

  incrementPlayerNbGames(roomId) {
    /* let tagObs = this.afd.database.object(`/players/${roomId}`);
    tagObs.$ref.transaction(tagValue => {
      return tagValue ? tagValue + 1 : 1;
    }); */
    let playerRef = this.afd.list('players/' + roomId);
    // todo improve (dirty quick map)
    return playerRef
      .snapshotChanges()
      .map(changes => {
        let nbGamesPlayed: number = changes
          .find(res => res.key === 'nbGamesPlayed')
          .payload.val() as number;
        this.updatePlayerPart(roomId, 'nbGamesPlayed', nbGamesPlayed + 1);
      })
      .pipe(take(1))
      .subscribe();
  }

  updatePlayerPart(roomId, key, data) {
    return this.playersRef.set(`${roomId}/${key}`, data);
  }
}
